import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import { signinUser, resetFetchProfiles, loginRedriect } from '../../actions';
import SignInForm from './forms/SignInForm';
import MyS4CUnAuthNav from './MyS4CUnAuthNav';
import { Link } from 'react-router-dom';
import translate from '../TranslateHOC';
import {
  PATH_FORGOT,
  PATH_AUTHENTICATED_REDIRECT,
  PATH_AUTHENTICATED_REDIRECT_SELECT_PROFILE,
} from '../../constants';
import MyS4CAPIErrorAlert from './alerts/MyS4CAPIErrorAlert';
import { AUTH_ERROR } from '../../actions/types';
import { device } from '../../v2/Theme';
import { rgba } from 'polished';

class MyS4CSignIn extends Component {
  // See EditAccountForm for example where error and submission handfling are tied to the form

  constructor(props) {
    super(props);
    this.handleSignInSubmit = this.handleSignInSubmit.bind(this);
  }

  componentDidMount = () => {
    //Make sure profiles is reset before login in
    if (!this.props.auth) {
      this.props.resetFetchProfiles();
      if (
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.loginRedirect &&
        this.props.location.state.loginRedirect.length > 0
      ) {
        this.props.loginRedriect(this.props.location.state.loginRedirect);
      }
    }
    if (
      this.props.auth &&
      ((this.props.profilesData &&
        this.props.profilesData.profiles &&
        this.props.profilesData.profiles.length > 0) ||
        this.props.profilesError)
    ) {
      //If user is already logged in redirect to the watching page
      this.props.history.push(PATH_AUTHENTICATED_REDIRECT);
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    //Check if user is logged in, if they are then redirect to profileSelect page and pass the loginRedirect State if there is one
    if (nextProps.auth) {
      this.props.history.push(PATH_AUTHENTICATED_REDIRECT_SELECT_PROFILE);
    }
  };

  handleSignInSubmit = (values) => {
    if (values.email && values.password) {
      //Form Submitted login the user, or show error
      return this.props.signinUser(values.email, values.password);
    }
  };

  renderAlertMessage() {
    const { errorSignInMessage } = this.props;
    if (errorSignInMessage) {
      return (
        <MyS4CAPIErrorAlert
          errorMessage={errorSignInMessage}
          errorType={AUTH_ERROR}
        />
      );
    }
  }

  renderTVLinkMessage() {
    const { stateLoginRedirect } = this.props;

    // Check if the user was redirected from /link or /linc
    if (
      stateLoginRedirect &&
      (stateLoginRedirect.endsWith('/link') ||
        stateLoginRedirect.endsWith('/linc'))
    ) {
      return (
        <TVLinkMessage>{this.props.strings.tvLinkSignInMessage}</TVLinkMessage>
      );
    }

    return null;
  }

  render() {
    const activeLocation = this.props.location.pathname;

    return (
      <div className="sign-in">
        <SignInFormContainer>
          <MyS4CUnAuthNav active={activeLocation} />
          {this.renderTVLinkMessage()}
          <SignInForm
            onSubmit={this.handleSignInSubmit}
            strings={this.props.strings}
          >
            {this.renderAlertMessage()}
            <Link className="form__forgot" to={PATH_FORGOT}>
              {this.props.strings.forgotPassword}
            </Link>
          </SignInForm>
        </SignInFormContainer>
        <BackgroundImage className="my-s4c-content__bg" />
      </div>
    );
  }
}

const SignInFormContainer = styled.section`
  background: ${(props) =>
    props.theme.name === 'light'
      ? 'rgba(251, 251, 251, 0.6);'
      : 'rgba(16, 16, 15, 0.6);'};
  border-radius: 12px;
  box-shadow: ${(props) =>
    props.theme.name === 'light'
      ? '0px 32px 64px rgba(0, 0, 0, 0.075), 0px 16px 32px rgba(0, 0, 0, 0.075), 0px 8px 16px rgba(0, 0, 0, 0.075), 0px 4px 8px rgba(0, 0, 0, 0.075)'
      : '0px 32px 64px rgba(0, 0, 0, 0.075), 0px 16px 32px rgba(0, 0, 0, 0.075), 0px 8px 16px rgba(0, 0, 0, 0.075), 0px 4px 8px rgba(0, 0, 0, 0.075)'};
  backdrop-filter: blur(24px);
  margin: 4.5em 20px;
  max-width: 474px;
  width: calc(100% - 40px);
  z-index: 9999;
  position: relative;
  left: 50%;
  margin-left: 0;
  margin-right: 0;
  margin-top: 8em;
  transform: translateX(-50%);
  a:hover,
  .link:hover {
    box-shadow: none !important;
  }
  @media ${device.tablet} {
    margin-top: 12em;
    .form {
      margin-bottom: 11em;
    }
  }
  .sub-header {
    background: none;
    border-radius: 12px 12px 0 0;
    box-shadow: none;

    .my-s4c-header {
      margin: 0;
    }
  }
  .sub-header a {
    padding-bottom: 23px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull} !important;
    font-size: 18px;
    line-height: 27px;
    &:hover {
      box-shadow: none;
    }
    &:focus-visible {
      box-shadow: ${(props) => props.theme.focusRing};
      border-radius: 4px;
      outline: none;
    }
    &:focus:not(:focus-visible) {
      outline: none;
    }
  }
  .my-s4c-header__nav--unauth {
    padding-left: 20px !important;
  }
  .my-s4c-header__link--active {
    font-weight: bold;
    &::before {
      bottom: -3px;
      left: 0;
      right: 0;
    }
  }
  .form {
    margin-bottom: 5em;
    max-width: none;
  }
  .form__header {
    padding: 0 20px;
  }
  .form--no-btm-pad {
    padding-bottom: 2px;
  }
  .form__instruct--pad-btm {
    padding-bottom: 24px;
  }
  .form__label {
    font-size: 20px;
    line-height: 24px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull};
  }
  .form__input {
    line-height: 22px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull};
    &::-webkit-input-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    &::-moz-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    &:-ms-input-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    &:-moz-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    background: ${(props) =>
      props.theme.name === 'light'
        ? 'rgba(16, 16, 15, 0.05);'
        : 'rgba(255, 255, 255, 0.05);'};
    border: 1px solid
      ${(props) =>
        props.theme.name === 'light'
          ? 'rgba(0, 0, 0, 0.1)'
          : 'rgba(255, 255, 255, 0.2);'};
    box-shadow: none;
    &:hover,
    &:active,
    &:focus-visible {
      color: ${(props) =>
        props.theme.name === 'dark' && props.theme.color.whiteFull};
    }
    &:focus-visible {
      box-shadow: ${(props) => props.theme.focusRing};
      outline: none;
    }
    &:focus:not(:focus-visible) {
      outline: none;
    }
  }
  .form__forgot {
    position: relative;
    margin: 0 20px 37px;
    font-size: 20px;
    line-height: 24px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.primaryAAA
        : props.theme.color.primaryFull};
    text-decoration: underline;
    text-underline-offset: 2px;
    &:focus-visible {
      box-shadow: ${(props) => props.theme.focusRing};
      border-radius: 4px;
      outline: none;
    }
    &:focus:not(:focus-visible) {
      outline: none;
    }
  }
  .form__actions > div {
    justify-content: center;
  }
  .alert-error {
    margin-bottom: 23px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull};
  }
`;

const BackgroundImage = styled.div`
  max-height: 800px;
  &:before {
    background: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.whiteFull
        : props.theme.color.blackFull};
    content: '';
    display: block;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    transition: opacity 75ms ease;
  }
  &:after {
    background: ${(props) =>
      props.theme.name === 'light'
        ? `
      linear-gradient(180deg, ${rgba(
        props.theme.color.whiteFull,
        0.15
      )} 0%, ${rgba(props.theme.color.whiteFull, 0.15735)} 6.67%, ${rgba(
            props.theme.color.whiteFull,
            0.180184
          )} 13.33%, ${rgba(props.theme.color.whiteFull, 0.219411)} 20%, ${rgba(
            props.theme.color.whiteFull,
            0.2753
          )} 26.67%, ${rgba(
            props.theme.color.whiteFull,
            0.347009
          )} 33.33%, ${rgba(props.theme.color.whiteFull, 0.432101)} 40%, ${rgba(
            props.theme.color.whiteFull,
            0.526288
          )} 46.67%, ${rgba(
            props.theme.color.whiteFull,
            0.623712
          )} 53.33%, ${rgba(props.theme.color.whiteFull, 0.717899)} 60%, ${rgba(
            props.theme.color.whiteFull,
            0.802991
          )} 66.67%, ${rgba(
            props.theme.color.whiteFull,
            0.8747
          )} 73.33%, ${rgba(props.theme.color.whiteFull, 0.930589)} 80%, ${rgba(
            props.theme.color.whiteFull,
            0.969817
          )} 86.67%, ${rgba(props.theme.color.whiteFull, 0.99265)} 93.33%, ${
            props.theme.color.whiteFull
          } 100%),
      linear-gradient(256.01deg, ${rgba(
        props.theme.color.whiteFull,
        0.075
      )} 44.8%, ${rgba(props.theme.color.whiteFull, 0.078675)} 47.31%, ${rgba(
            props.theme.color.whiteFull,
            0.090092
          )} 49.81%, ${rgba(
            props.theme.color.whiteFull,
            0.1097055
          )} 52.32%, ${rgba(
            props.theme.color.whiteFull,
            0.13765
          )} 54.82%, ${rgba(
            props.theme.color.whiteFull,
            0.1735045
          )} 57.33%, ${rgba(
            props.theme.color.whiteFull,
            0.2160505
          )} 59.83%, ${rgba(
            props.theme.color.whiteFull,
            0.263144
          )} 62.34%, ${rgba(
            props.theme.color.whiteFull,
            0.311856
          )} 64.84%, ${rgba(
            props.theme.color.whiteFull,
            0.3589495
          )} 67.35%, ${rgba(
            props.theme.color.whiteFull,
            0.4014955
          )} 69.85%, ${rgba(
            props.theme.color.whiteFull,
            0.43735
          )} 72.36%, ${rgba(
            props.theme.color.whiteFull,
            0.4652945
          )} 74.86%, ${rgba(
            props.theme.color.whiteFull,
            0.4849085
          )} 77.37%, ${rgba(props.theme.color.whiteFull, 0.496325)} 79.87%, ${
            props.theme.color.whiteFull
          } 82.38%),
      linear-gradient(89.96deg, ${props.theme.color.whiteFull} 1.34%, ${rgba(
            props.theme.color.whiteFull,
            0
          )} 50.03%)
    `
        : `
      linear-gradient(180deg, ${rgba(
        props.theme.color.blackFull,
        0.15
      )} 0%, ${rgba(props.theme.color.blackFull, 0.15735)} 6.67%, ${rgba(
            props.theme.color.blackFull,
            0.180184
          )} 13.33%, ${rgba(props.theme.color.blackFull, 0.219411)} 20%, ${rgba(
            props.theme.color.blackFull,
            0.2753
          )} 26.67%, ${rgba(
            props.theme.color.blackFull,
            0.347009
          )} 33.33%, ${rgba(props.theme.color.blackFull, 0.432101)} 40%, ${rgba(
            props.theme.color.blackFull,
            0.526288
          )} 46.67%, ${rgba(
            props.theme.color.blackFull,
            0.623712
          )} 53.33%, ${rgba(props.theme.color.blackFull, 0.717899)} 60%, ${rgba(
            props.theme.color.blackFull,
            0.802991
          )} 66.67%, ${rgba(
            props.theme.color.blackFull,
            0.8747
          )} 73.33%, ${rgba(props.theme.color.blackFull, 0.930589)} 80%, ${rgba(
            props.theme.color.blackFull,
            0.969817
          )} 86.67%, ${rgba(props.theme.color.blackFull, 0.99265)} 93.33%, ${
            props.theme.color.blackFull
          } 100%),
      linear-gradient(256.01deg, ${rgba(
        props.theme.color.blackFull,
        0.075
      )} 44.8%, ${rgba(props.theme.color.blackFull, 0.078675)} 47.31%, ${rgba(
            props.theme.color.blackFull,
            0.090092
          )} 49.81%, ${rgba(
            props.theme.color.blackFull,
            0.1097055
          )} 52.32%, ${rgba(
            props.theme.color.blackFull,
            0.13765
          )} 54.82%, ${rgba(
            props.theme.color.blackFull,
            0.1735045
          )} 57.33%, ${rgba(
            props.theme.color.blackFull,
            0.2160505
          )} 59.83%, ${rgba(
            props.theme.color.blackFull,
            0.263144
          )} 62.34%, ${rgba(
            props.theme.color.blackFull,
            0.311856
          )} 64.84%, ${rgba(
            props.theme.color.blackFull,
            0.3589495
          )} 67.35%, ${rgba(
            props.theme.color.blackFull,
            0.4014955
          )} 69.85%, ${rgba(
            props.theme.color.blackFull,
            0.43735
          )} 72.36%, ${rgba(
            props.theme.color.blackFull,
            0.4652945
          )} 74.86%, ${rgba(
            props.theme.color.blackFull,
            0.4849085
          )} 77.37%, ${rgba(props.theme.color.blackFull, 0.496325)} 79.87%, ${
            props.theme.color.blackFull
          } 82.38%),
      linear-gradient(89.96deg, ${props.theme.color.blackFull} 1.34%, ${rgba(
            props.theme.color.blackFull,
            0
          )} 50.03%)
    `};
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
    content: '';
  }
`;

const TVLinkMessage = styled.div`
  font-weight: bold;
  margin: 20px 20px 0;
  padding: 15px 20px;
  background-color: ${(props) =>
    props.theme.name === 'light'
      ? 'rgba(16, 16, 15, 0.05);'
      : 'rgba(251, 251, 251, 0.05);'};
  border-radius: 4px;
  font-size: 16px;
  line-height: 22px;
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.blackFull
      : props.theme.color.whiteFull};
`;

function mapStateToProps(state) {
  return {
    auth: state.auth.authenticated,
    curLang: state.curLang,
    errorSignInMessage: state.auth.error,
    profilesData: state.profilesData.success,
    profilesError: state.profilesData.error,
    stateLoginRedirect: state.loginRedirect,
  };
}

export default translate(
  connect(mapStateToProps, { signinUser, resetFetchProfiles, loginRedriect })(
    MyS4CSignIn
  )
);
